<template>
    <el-dialog :custom-class="'user-dialog'" :visible="dialogvisible" width="40%"
               @close="$emit('update:dialogvisible', false); visiblePassword=false">
        <div class="avatar-box">
            <img :src="imagePlaceholder"
                 alt="user avatar">
        </div>
        <el-form notification-icon :model="hekimForm" :rules="rulesDoktor" ref="hekimForm"
                 class="demo-ruleForm">
            <div class="card-base card-shadow--medium">
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item label="İsim Soyisim :" prop="adSoyad">
                            <el-input  v-on:input="inputStyleAlt(hekimForm.adSoyad,'adSoyad')" v-model="hekimForm.adSoyad"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item label='Telefon :' prop="telefon">
                            <el-input v-model="hekimForm.telefon" v-mask="'+90(###)### ## ##'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item label='E-Posta :' prop="eposta">
                            <el-input v-model="hekimForm.eposta"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <div v-for="(item,index) in klinikList"
                         class="animated fadeInLeft">
                        <el-row class="mb-10">
                            <el-col :span="24" >
                                <el-col :lg="11" :md="11" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='İl :' prop="il">
                                        <el-select
                                                v-model="klinikList[index]['ilId']"
                                                filterable
                                                placeholder='İl Seçiniz'
                                                style="width: 100%">
                                            <el-option v-for="item in ilList"
                                                       :key="item.baslik"
                                                       :label="item.baslik"
                                                       :value="item.ilId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="11" :md="11" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Klinik :' prop="baslik">
                                        <el-input
                                                v-model="klinikList[index]['baslik']"
                                                placeholder='Klinik Giriniz'>

                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-button v-if="klinikList.length>1" class="deleteButton margin-top-25" type="danger" size="mini"
                                           icon="el-icon-close" v-on:click="removeKlinik(index)"
                                           circle></el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <el-button style="float: right" class="margin-right-30 estas-buton-border" size="mini" plain type="primary" v-on:click="klinikEkle">Klinik Ekle</el-button>

                </el-row>
                <el-row class="col-p">
                    <el-form-item>
                        <el-button v-on:click="hekimTanimlama('hekimForm')" size="mini" type="primary" class="estas-buton">
                            Hekim Tanımla
                        </el-button>&nbsp;
                        <el-button class="estas-buton-border" v-on:click="dialogvisible=false" size="mini">
                            Vazgeç
                        </el-button>&nbsp;
                    </el-form-item>
                </el-row>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
    import ilService from '../WSProvider/IlService'
    import hekimService from '../WSProvider/HekimService'
    import notification from '../notification'
    import EventBus from '@/components/event-bus'
    let base64 = require('base64_js');
    let userData3H = "";
    export default {
        name: 'HekimTanimlama',
        props: ['userdatadoktor', 'dialogvisible'],
        data() {
            return {
                visiblePassword: false,
                ilList: [],
                klinikList: [{
                    ilId: '',
                    baslik: '',
                }],
                doktor: this.userdatadoktor,
                imagePlaceholder: 'data:image/jpeg;base64,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',
                hekimForm: {
                    adSoyad: '',
                    eposta: '',
                    il: '',
                    klinik: '',
                    telefon: ''
                },
                rulesDoktor: {
                    adSoyad: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }

        },
        mounted() {
            this.getIl();
        },
        methods: {
            klinikEkle() {
                this.klinikList.push({
                    ilId: '',
                    baslik: '',
                })
            },
            removeKlinik(item) {
                this.klinikList.splice(item, 1);
            },
            getIl() {
                ilService.il().then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            inputStyleAlt(val, model) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hekimForm[model] = splitStr.join(' ');
            },
            hekimTanimlama() {
                hekimService.hekimKaydi(this.hekimForm.eposta, this.hekimForm.adSoyad, this.klinikList, this.hekimForm.telefon).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Hekim başarıyla kaydedildi.');
                        EventBus.$emit("hekimList",true)
                        this.hekimForm.adSoyad = '';
                        this.hekimForm.telefon = '';
                        this.hekimForm.eposta = '';
                        this.klinikList = [];
                    } else notification.Status(response.status, this);
                })
            }
        }
    }
</script>

